(function () {
 'use strict';
 if (customElements.get('barbara-size-finder')) return;
 class BarbaraSizeFinder extends HTMLElement {
  connectedCallback() {
   if (this.initialized || !globalThis.BarbaraSizeFinderEngine) return;
   this.initialized = true;
   this.modelData = new Map([...this.querySelectorAll('[data-be-size-data]')].map(el => [el.dataset.beSizePattern, JSON.parse(el.textContent)]));
   this.modelControl = this.querySelector('[data-be-size-model]');
   this.copy = JSON.parse(this.querySelector('[data-be-size-copy]').textContent);
   this.form = this.querySelector('form');
   this.unitControl = this.querySelector('[data-be-size-unit]');
   this.unit = this.unitControl.value;
   const requestedModel = new URL(location.href).searchParams.get('model') || 'brigitte';
   this.modelControl.value = this.modelData.has(requestedModel) ? requestedModel : '';
   this.selectModel();
   this.fields = Object.fromEntries([...this.querySelectorAll('[data-be-size-field]')].map(e => [e.dataset.beSizeField, e]));
   this.result = this.querySelector('[data-be-size-result]');
   this.empty = this.querySelector('[data-be-size-empty]');
   this.error = this.querySelector('[data-be-size-error]');
   this.warning = this.querySelector('[data-be-size-warning]');
   this.alternative = this.querySelector('[data-be-size-alternative]');
   this.stop = this.querySelector('[data-be-size-stop]');
   this.inputStop = this.querySelector('[data-be-size-input-stop]');
   this.alternativeText = this.querySelector('[data-be-size-alternative-text]');
   this.resultHeading = this.querySelector('[data-be-size-result-heading]');
   this.submitButton = this.querySelector('[type="submit"]');
   this.submitLabel = this.submitButton.textContent;
   this.modelControl.addEventListener('change', () => {
    this.selectModel();
    this.clear();
    const url = new URL(location.href);
    if (this.data) url.searchParams.set('model', this.modelControl.value);
    else url.searchParams.delete('model');
    history.replaceState(history.state, '', url);
   });
   this.form.addEventListener('submit', e => { e.preventDefault(); this.calculate(true); });
   for (const field of Object.values(this.fields)) {
    field.addEventListener('input', () => this.clear());
   }
   this.unitControl.addEventListener('change', () => {
    const previousUnit = this.unit;
    this.unit = this.unitControl.value;
    for (const field of Object.values(this.fields)) {
     const n = globalThis.BarbaraSizeFinderEngine.parseMeasurement(field.value);
     if (n !== null) {
      const cm = previousUnit === 'in' ? n * 2.54 : n;
      field.value = this.inputFormat(this.unit === 'in' ? cm / 2.54 : cm);
     }
    }
    for (const label of this.querySelectorAll('[data-be-size-unit-label]')) label.textContent = this.unit;
    if (this.hasResult) this.calculate(false);
    else this.clear();
   });
  }
  selectModel() {
   this.data = this.modelData.get(this.modelControl.value) || null;
   for (const el of this.querySelectorAll('[data-be-size-model-context]')) el.hidden = !this.data;
  }
  ukSize(size) { return this.data.size_system.uk[this.data.size_system.eu.indexOf(size.eu)]; }
  inputFormat(number) { return number.toFixed(6).replace(/\.?0+$/, ''); }
  format(cm, precision = 1) {
   const n = this.unit === 'in' ? cm / 2.54 : cm;
   const locale = document.documentElement.lang.startsWith('de') ? 'de-DE' : 'en-US';
   return new Intl.NumberFormat(locale, { maximumFractionDigits: precision }).format(n) + ' ' + this.unit;
  }
  clear() {
   this.hasResult = false;
   this.stop.hidden = true;
   this.inputStop.hidden = true;
   this.result.hidden = true;
   this.empty.hidden = false;
   this.error.hidden = true;
   this.error.textContent = '';
   this.warning.hidden = true;
   this.warning.textContent = '';
   this.alternative.hidden = true;
   this.alternativeText.textContent = '';
   this.resultHeading.textContent = this.copy.result_heading;
   this.submitButton.textContent = this.submitLabel;
   for (const field of Object.values(this.fields)) field.removeAttribute('aria-invalid');
  }
  showInputStop(message) {
   this.hasResult = true;
   this.empty.hidden = true;
   this.inputStop.querySelector('[data-be-size-input-stop-body]').textContent = message;
   this.inputStop.hidden = false;
  }
  calculate(moveFocus) {
   const values = Object.fromEntries(Object.entries(this.fields).map(([key, field]) => [key, field.value]));
   // Only BRIGITTE is verified. Future products need their own data and engine adapter.
   if (!this.data || this.data.product_id !== 'BEC-001') {
    this.clear();
    this.error.textContent = this.copy.error_model;
    this.error.hidden = false;
    if (moveFocus) this.modelControl.focus();
    return;
   }
   const comparison = globalThis.BarbaraSizeFinderEngine.compare(this.data, values, this.unit);
   this.clear();
   if (comparison.status === 'invalid_measurements') {
    const measurements = comparison.fields.map(key => this.copy[key] + ': ' + this.format(comparison.cm[key])).join('; ');
    const errorCopy = comparison.reason === 'proportions' ? this.copy.error_proportions : this.copy.error_range;
    this.showInputStop(errorCopy.replace('{measurements}', measurements));
    for (const key of comparison.fields) this.fields[key].setAttribute('aria-invalid', 'true');
    if (moveFocus) this.fields[comparison.fields[0]].focus();
    return;
   }
   if (comparison.status === 'fit_stop') {
    this.hasResult = true;
    this.empty.hidden = true;
    const factor = this.unit === 'in' ? 1 / 2.54 : 1;
    const boundaryPrecision = Math.round(comparison.room.bust * factor * 10) === Math.round(comparison.minimumAutoBustRoom * factor * 10) ? 6 : 1;
    this.stop.querySelector('[data-be-size-stop-body]').textContent = this.copy.stop_body
     .replace('{eu}', comparison.eu).replace('{us}', comparison.us).replace('{uk}', this.ukSize(comparison))
     .replace('{actual}', this.format(comparison.room.bust, boundaryPrecision))
     .replace('{minimum}', this.format(comparison.minimumAutoBustRoom, boundaryPrecision))
     .replace('{reference}', this.format(comparison.modelBustRoom));
    const arm = this.stop.querySelector('[data-be-size-stop-arm]');
    arm.hidden = !comparison.armNeedsReview;
    arm.textContent = comparison.armNeedsReview ? this.copy.warning_arm_room
     .replace('{actual}', this.format(comparison.room.upper_arm))
     .replace('{reference}', this.format(this.data.minimum_upper_arm_room_cm)) : '';
    const alternative = this.stop.querySelector('[data-be-size-stop-alternative]');
    alternative.hidden = !comparison.alternative;
    if (comparison.alternative) {
     const next = comparison.alternative;
     alternative.textContent = this.copy.stop_alternative.replace('{eu}', next.eu).replace('{us}', next.us).replace('{uk}', this.ukSize(next))
      .replace('{bust}', this.format(next.room.bust)).replace('{waist}', this.format(next.room.waist)).replace('{hip}', this.format(next.room.hip));
    } else alternative.textContent = '';
    this.stop.hidden = false;
    if (moveFocus) {
     this.stop.focus({ preventScroll: true });
     if (matchMedia('(max-width: 749px)').matches) this.stop.scrollIntoView({ block: 'start' });
    }
    return;
   }
   if (comparison.status !== 'match') {
    const errorKey = { invalid: 'error_invalid', outside_chart: 'error_outside', no_match: 'error_no_match' }[comparison.status];
    this.error.textContent = this.copy[errorKey];
    if (comparison.lowRoomFields?.length) {
     const measurements = comparison.lowRoomFields.map(key => this.copy[key] + ': ' + this.format(comparison.room[key])).join('; ');
     this.error.textContent += ' ' + this.copy.warning_low_room.replace('{measurements}', measurements);
    }
    if (comparison.status === 'invalid') this.showInputStop(this.error.textContent);
    else this.error.hidden = false;
    const affected = comparison.field ? [comparison.field] : comparison.fields || [];
    for (const key of affected) this.fields[key].setAttribute('aria-invalid', 'true');
    if (moveFocus && affected[0]) this.fields[affected[0]].focus();
    return;
   }
   this.hasResult = true;
   this.empty.hidden = true;
   this.querySelector('[data-be-size-number]').textContent = 'EU ' + comparison.eu + ' / US ' + comparison.us + ' / UK ' + this.ukSize(comparison);
   for (const [key] of Object.entries(this.fields)) {
    const row = this.querySelector('[data-be-size-row="' + key + '"]');
    row.hidden = comparison.cm[key] === undefined;
    if (row.hidden) continue;
    row.querySelector('[data-be-size-body]').textContent = this.format(comparison.cm[key]);
    row.querySelector('[data-be-size-finished]').textContent = this.format(comparison.finishedByField[key]);
    row.querySelector('[data-be-size-room]').textContent = this.format(comparison.room[key]);
   }
   const warnings = [];
   if (comparison.smallestSize) warnings.push(this.copy.warning_smallest_size);
   if (comparison.lowRoomFields.length) {
    const measurements = comparison.lowRoomFields.map(key => this.copy[key] + ': ' + this.format(comparison.room[key])).join('; ');
    warnings.push(this.copy.warning_low_room.replace('{measurements}', measurements));
   }
   if (comparison.reducedBustRoom) {
    warnings.push(this.copy.warning_reference_bust.replace('{actual}', this.format(comparison.room.bust)).replace('{reference}', this.format(comparison.modelBustRoom)));
   }
   if (comparison.armNeedsReview) {
    warnings.push(this.copy.warning_arm_room.replace('{actual}', this.format(comparison.room.upper_arm)).replace('{reference}', this.format(this.data.minimum_upper_arm_room_cm)));
   }
   if (comparison.adjustedForBody) warnings.push(this.copy.warning_proportions);
   if (warnings.length) {
    this.warning.textContent = warnings.join(' ');
    this.warning.hidden = false;
   }
   this.resultHeading.textContent = comparison.comparisonOnly ? this.copy.comparison_heading : this.copy.result_heading;
   if (comparison.alternative) {
    const alternative = comparison.alternative;
    this.alternativeText.textContent = this.copy.alternative_size.replace('{eu}', alternative.eu).replace('{us}', alternative.us).replace('{uk}', this.ukSize(alternative))
     .replace('{bust}', this.format(alternative.room.bust)).replace('{waist}', this.format(alternative.room.waist)).replace('{hip}', this.format(alternative.room.hip));
    this.alternative.hidden = false;
   }
   this.result.hidden = false;
   if (moveFocus) {
    this.result.focus({ preventScroll: true });
    if (matchMedia('(max-width: 749px)').matches) this.result.scrollIntoView({ block: 'start' });
   }
  }
 }
 customElements.define('barbara-size-finder', BarbaraSizeFinder);
})();


